import { Component, ElementRef, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output, Renderer2, } from "@angular/core";
import { exposeComponentInDebugMode } from "../misc/expose-component-in-debug-mode.decorator";
import { NG_VALUE_ACCESSOR, SelectControlValueAccessor } from "@angular/forms";
import { Subscription } from "rxjs/Subscription";
import { createEvent } from "../misc/event.polyfill";
import { PrivilegeViewService } from "./privilege-view.service";


export function makeSelectPrivilegeViewComponentProvider() {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectPrivilegeViewComponent),
    multi: true,
  };
}

@Component({
  selector: "select-privilege-view",
  templateUrl: "./select-privilege-view.template.pug",
  providers: [makeSelectPrivilegeViewComponentProvider()],
  styles: [
    `.selected-item{
      cursor: none!important;
      border: 1px solid #0096d6;
      color: #0096d6;
      pointer-events: none;
    }`,
  ],
})
@exposeComponentInDebugMode({ multi: true })
export class SelectPrivilegeViewComponent extends SelectControlValueAccessor implements OnInit, OnDestroy {
  private _value: string;
  private subscription: Subscription;
  private privilegeSubscription: Subscription;
  porFlag = false;
  selectedText = "";
  domain: string = "";

  @Output("onChange")
  public onChangeEmitter: any = new EventEmitter();

  @Input()
  blank: boolean;

  @Input()
  inputId: string;

  @Input()
  inputName: string;

  @Input()
  disabled: boolean;

  @Input()
  error: Error;

  private emitOnChange(obj: string, oldObj: string): void {
    const event = createEvent("change");
    event["value"] = obj;
    event["oldValue"] = oldObj;
    this.onChangeEmitter.emit(event);
  }

  onChange = (_) => { }; // eslint-disable-line
  onTouched = () => { };

  get value(): string {
    return this._value;
  }

  set value(obj: string) {
    const oldObj = this._value;
    this._value = obj;

    this.onChange(obj);
    this.emitOnChange(obj, oldObj);
  }

  writeValue(obj: string) {
    this._value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private privilegeViewService: PrivilegeViewService,
  ) {
    super(renderer, elementRef);
  }

  ngOnInit(): void {
    this.domain = this.privilegeViewService.getDomainView();
    this.privilegeSubscription = this.privilegeViewService.privilegeData.subscribe((data) => {
      this.value = data.domainView;
      this.setText(data.domainView);
      this.porFlag = data.flag;
      this.domain = this.privilegeViewService.getDomainView();
    });
  }

  setText(val) {
    if (val === "cusReseller") {
      this.selectedText = "Customer-Reseller";
    } else if (val === "fedLLC") {
      this.selectedText = "Fed LLC";
    }
  }

  selectViewAs(param) {
    if (this.value !== param) {
      this.value = param;
      this.setText(param);
      this.privilegeViewService.switchView(param);
    }
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
  }
}
